import { Box, Typography, Button, Container } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useNavigate } from "react-router-dom"
import { StandardButton } from "../../../../../../../shared/components/buttons/StandardButton"
import { USER_REPORTS_ROUTE } from "../../../../../../../constants/routes"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../../shared/components/pageHeader/PageHeaderApi"
import { useLocationState } from "../../../../../../../core/router/routerHooks"
import { ITransactionResponse } from "../../../../../../payments/transactionTypes"

const useStyles = makeStyles()((theme) => ({
    container: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(3),
    },
    content: {
        padding: theme.spacing(4),
        maxWidth: 500,
        width: "100%",
        textAlign: "center",
    },
    title: {
        fontWeight: 600,
        marginBottom: theme.spacing(3),
        color: theme.palette.text.primary,
    },
    description: {
        color: theme.palette.text.secondary,
        lineHeight: 1.6,
        marginBottom: theme.spacing(4),
    },
}))

export function UserWalletsRefillStatusSuccess() {
    const { classes } = useStyles()
    const navigate = useNavigate()
    const { response } = useLocationState<{ response: ITransactionResponse }>({
        response: {
            subject: "",
            message: "",
        },
    })

    const backToDashboard = () => navigate(USER_REPORTS_ROUTE)

    return (
        <>
            <LocalizedStrict id="user-wallets-refill-title" attrs={{ title: true }}>
                <PageHeader page={Page.USER_WALLETS_REFILL} title="Refill wallet" />
            </LocalizedStrict>
            <Container className={classes.container}>
                <Box className={classes.content}>
                    <Typography variant="h4" className={classes.title}>
                        {response.subject}
                    </Typography>

                    <Typography variant="body1" className={classes.description}>
                        {response.message}
                    </Typography>

                    <LocalizedStrict id="user-wallets-refill-payment-back-action-button-label">
                        <StandardButton defaultBorderRadius color="black" onClick={backToDashboard} fullWidth={false}>
                            Back to dashboard
                        </StandardButton>
                    </LocalizedStrict>
                </Box>
            </Container>
        </>
    )
}
